import React, { useRef } from 'react';
import { Box, IconButton, Paper, Popper } from '@material-ui/core';
import { Settings as SettingsIcon } from '@material-ui/icons';
import ColumnSelect from '@/se/components/collection/ColumnSelect';

export interface Column {
  key: string;
  title: string;
}

export interface ColumnSetting extends Column {
  visible: boolean;
}

export interface TableSettings {
  columns: ColumnSetting[];
}

export interface TableSettingsProps {
  columns: Column[];
  settings: TableSettings;
  onChange: (settings: TableSettings) => void;
}

// eslint-disable-next-line no-redeclare
const TableSettings = ({ columns, settings, onChange }: TableSettingsProps) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const buttonRef = useRef(null);

  const handleSettingsClick = event => {
    if (openSettings) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleCloseSettings = () => {
    setAnchorEl(null);
  };

  const openSettings = Boolean(anchorEl);
  const idSettings = openSettings ? 'settings-popper' : undefined;

  return (
    <Box>
      <IconButton onClick={handleSettingsClick} ref={buttonRef}>
        <SettingsIcon />
      </IconButton>
      <Popper style={{ zIndex: 2 }} id={idSettings} open={openSettings} anchorEl={anchorEl}>
        <Paper>
          <ColumnSelect
            keepOpen
            options={columns}
            labelField="title"
            valueField="key"
            values={settings.columns}
            onChange={columns => onChange({ columns })}
            onClose={handleCloseSettings}
            buttonRef={buttonRef}
          />
        </Paper>
      </Popper>
    </Box>
  );
};

export default TableSettings;
